import React, { useState, useEffect } from 'react'
import OpenPlayerJS from 'openplayerjs';
import "../../../../assets-static/openplayerjs-youtube/dist/openplayerjs-youtube.min.js"

const TrailerVideo = ({trailerURL, prerollUrl, isMobile}) => {
    useEffect(() => {
        let prerollUrlWithRandomNumber

        if(prerollUrl) {
            var splittedPrerollUrl = prerollUrl.split("correlator=");
            var splittedPrerollUrlWithoutPlaceholder = splittedPrerollUrl[1].substring(splittedPrerollUrl[1].indexOf('&vpmute'), splittedPrerollUrl[1].length);
            const randomNumber = Math.floor(Math.random()*10000000000000000)
            const timeStamp = new Date().getTime()
            const correlator = 'correlator=' + randomNumber + timeStamp
            prerollUrlWithRandomNumber = splittedPrerollUrl[0] + correlator + splittedPrerollUrlWithoutPlaceholder
        }

        let acceptedCookies = typeof googletag === 'undefined' || googletag === null ? false : true
        
        function addPlayer() {
            let player
            
            if(prerollUrl && acceptedCookies) {
                player = new OpenPlayerJS('player', {
                    ads: {
                        src: prerollUrlWithRandomNumber,
                        enablePreloading: true
                    },
                    hidePlayBtnTimer: 100,
                    youtube: {
                        controls:0,
                        modestbranding:1,
                        autoplay: 0
                    }
                });
            } else {
                player = new OpenPlayerJS('player', {
                    hidePlayBtnTimer: 100,
                    youtube: {
                        controls:0,
                        modestbranding:1,
                        autoplay: 1
                    }
                });
            }
            
            player.init();
        }
        
        setTimeout( () => addPlayer(), 500)

        //TODO
        // if(isMobile) {
        //     const div = document.getElementById("trailer-container");
        //     if (div.requestFullscreen) {
        //         div.requestFullscreen();
        //     }
        //     else if (div.webkitRequestFullscreen) {
        //         div.webkitRequestFullscreen();
        //     }
        //     else if (div.msRequestFullScreen) {
        //         div.msRequestFullScreen();
        //     }
        // }
        
        return function cleanup() {
            addPlayer();
        };
    });
    
    if(!trailerURL) {
        return ''
    } else {        
        return (
            <div className="trailer-container" id="trailer-container">
                <video className="op-player__media" id="player" playsInline>
                    <source src={trailerURL} type="video/x-youtube"/>
                </video>
            </div>
        )
    }
}

export default TrailerVideo